export type Section =
  | 'about'
  | 'home'
  | 'favourites'
  | 'shop'
  | 'gallery'
  | 'posts';

export interface SectionsState {
  active: Section;
  isLoading: boolean;
}

export enum SectionViewType {
  LIST = 'list',
  GRID = 'grid',
}
